var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", [_vm._v("form goes here")]),
      _vm._v(" "),
      _c("address-book-form", {
        attrs: { payload: _vm.payload },
        on: { save: _vm.save }
      }),
      _vm._v(" "),
      _c("div", [
        _c("button", { on: { click: _vm.clear } }, [_vm._v("Clear")])
      ]),
      _vm._v(" "),
      _c("div", [
        _vm._v("\n    My Addresses\n    "),
        _c(
          "ul",
          _vm._l(_vm.addresses, function(address, index) {
            return _c("li", { key: index }, [
              _c("div", [
                _c("div", [
                  _vm._v(
                    "Name: " +
                      _vm._s(address.first_name) +
                      " " +
                      _vm._s(address.last_name)
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Address Line 1:" + _vm._s(address.line_1))]),
                _vm._v(" "),
                _c("div", [_vm._v("Address Line 2:" + _vm._s(address.line_2))]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "Suburb, City: " +
                      _vm._s(address.suburb) +
                      " " +
                      _vm._s(address.city)
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Post Code: " + _vm._s(address.post_code))]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          return _vm.edit(index)
                        }
                      }
                    },
                    [_vm._v("Edit")]
                  ),
                  _vm._v(" | "),
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          return _vm.remove(index)
                        }
                      }
                    },
                    [_vm._v("Delete")]
                  )
                ])
              ])
            ])
          }),
          0
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15eff744", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15eff744","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/modulatte-core/address/Index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-15eff744","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/modulatte-core/address/Index.vue
// module chunks = 1